const eventBus: any = {};

export function addEventListener(params: { webviewId: string; eventName: string; cid: string }) {
  eventBus[params.webviewId] = {
    [params.eventName]: params.cid
  };
}

export function removeEventListener(params: { webviewId: string; eventName: string }) {
  if (eventBus[params.webviewId] && eventBus[params.webviewId][params.eventName]) {
    delete eventBus[params.webviewId][params.eventName];
  }
}

export function trigger(params: { webviewId: string; eventName: string }) {
  if (!eventBus[params.webviewId] || !eventBus[params.webviewId][params.eventName]) {
    return false;
  }
  const cid = eventBus[params.webviewId][params.eventName];
  const wv: any = document.getElementById(`thridapp-${params.webviewId}`);
  wv?.send("clientMessage", {
    cid: cid
  });
  return true;
}

export { eventBus };
